import apiBaseUrl from '../../utils/config.js';

class AppointmentsService {
  constructor() {
    this.baseUrl = `${apiBaseUrl}/appointments`;
  }

  getToken() {
    return localStorage.getItem("jwt");
  }

  getAuthHeaders() {
    const token = this.getToken();
    return {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    };
  }

  async request(endpoint, method, body = null) {
    const options = {
      method,
      headers: this.getAuthHeaders(),
    };

    if (body) {
      options.body = JSON.stringify(body);
    }

    const response = await fetch(`${this.baseUrl}${endpoint}`, options);

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Request failed: ${errorText}`);
    }

    const text = await response.text();

    if (!text) {
      return null;
    }

    return JSON.parse(text);
  }

  /*
   * OLD restrictive appointment add.
   * Keep this for backward compatibility only.
   * Normal scheduling should NOT use this anymore.
   */
  async addAppointment(appointment) {
    return this.request("/add", "POST", appointment);
  }

  /*
   * NEW old-appointment superbill creator endpoint.
   * This creates an old appointment as Completed and creates the superbill automatically.
   */
  async createSuperbillAppointment(appointment) {
    return this.request("/create-superbill-appointment", "POST", appointment);
  }

  async getAllAppointments() {
    return this.request("/all", "GET");
  }

  async updateAppointment(id, appointment) {
    return this.request(`/update/${id}`, "PUT", appointment);
  }

  async deleteAppointment(id) {
    return this.request(`/delete/${id}`, "DELETE");
  }

  async getAppointmentsByOffice(officeId) {
    return this.request(`/office/${officeId}`, "GET");
  }

  async getAppointmentsByDoctor(doctorId) {
    return this.request(`/doctor/${doctorId}`, "GET");
  }

  async getAppointmentsByDiagComb(diagCombId) {
    return this.request(`/diag/${diagCombId}`, "GET");
  }

  async getAppointmentsByDate(date) {
    return this.request(`/date/${date}`, "GET");
  }

  async updateTypeVisit(id, oldVisit, newVisit) {
    const params = new URLSearchParams({ oldVisit, newVisit });
    return this.request(`/update-typevisit/${id}?${params.toString()}`, "PUT");
  }

  /*
   * Old appointment available times.
   * Superbill creator may still use this if you want to match old flow.
   * Simple appointments should use SimpleAppointmentService.getAvailableTimes().
   */
  async getAvailableTimes(officeId, date) {
    return this.request(
      `/available-times?officeId=${officeId}&date=${date}`,
      "GET"
    );
  }

  async getAppointmentById(appointmentId) {
    return this.request(`/${appointmentId}`, "GET");
  }

  async getAppointmentsByOfficeAndDate(officeId, date) {
    return this.request(
      `/by-office-and-date?officeId=${officeId}&date=${date}`,
      "GET"
    );
  }

  /*
   * Old appointment status update.
   * This can create superbills when status becomes Completed.
   * Do NOT use this for simple check-in.
   */
  async updateConformationOnly(id, conformation) {
    return this.request(`/update-conformation/${id}`, "PATCH", { conformation });
  }
}

export default AppointmentsService;